import React, { LegacyRef } from 'react';
import styles from './Dropdown.module.scss';

type Positions = 'top' | 'right' | 'bottom' | 'left' | 'top-end' | 'bottom-start';
type Coordinates = { left?: number, top?: number };

type PositionProps =
  | { position: Positions, coordinates?: never }
  | { position?: never, coordinates: Coordinates };

type CommonProps = {
  children: ReactChildren;
  className?: string;
  id?: string;
  open: boolean;
  role?: string;
};

type DropdownMenuProps = CommonProps & PositionProps;

const DropdownMenu = React.forwardRef(({ children, className, coordinates, id, open, position, role = 'menu' }: DropdownMenuProps, ref: LegacyRef<HTMLDivElement>) => (
  <div
    ref={ref}
    aria-hidden={!open}
    className={`${styles.dropdown} ${open ? '' : styles.closed} ${styles[position]} ${className}`}
    id={id}
    role={role}
    style={coordinates}
  >
    {children}
  </div>
));

export default DropdownMenu;
